import styled from 'styled-components';

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  line-height: 26px;
`;

const Comment = styled.div`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-size: 16px;
  line-height: 24px;
`;

export { Title, Comment };
